/**
 * One row per id, keeping the LAST copy: rows are appended in the order they were fetched, so the last copy is the
 * newest state (a confirmation retried meanwhile comes back, stored, on a later page). It takes the place of the
 * last copy, so rows keep the server's order for the page that holds the latest state.
 */
export function latestById<T extends { id: string }>(rows: T[]): T[] {
  const last = new Map<string, number>();
  rows.forEach((r, i) => last.set(r.id, i));
  return rows.filter((r, i) => last.get(r.id) === i);
}
